import React from 'react';

import { Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { rem } from '@helpers';

import { Container, List, ListItem } from './animation';
import { useListTextAnimationHelper } from './listTextAnimation.helper';

export const ListTextAnimation: React.FC = () => {
	const { listTextAnimation, paletteUi9, hasText } = useListTextAnimationHelper();

	const listItems = React.useMemo(() => {
		let items = undefined;
		if (hasText) {
			items = listTextAnimation.map((textAnimation, index) => {
				return (
					<ListItem key={index}>
						<Typography
							alternativeStyleProperties={{
								color: paletteUi9,
							}}
							appearance="body-100-02"
						>
							{textAnimation.text}
						</Typography>
					</ListItem>
				);
			});
		}
		return items;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasText]);

	return (
		<>
			{hasText && (
				<div style={{ width: rem(300) }}>
					<Container>
						<List style={{ padding: 0 }}>{listItems}</List>
					</Container>
				</div>
			)}
		</>
	);
};
